import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import React from 'react'
import { useAppTranslations } from '../../utils/hooks/useAppTranslations'

type AutoReloadSelectFieldProps = {
  getIntervalLabel: (intervalKey: string) => string
  intervalKeys: string[]
  onIntervalChange: (interval: string) => void
  selectedInterval: string
  storageKey: string
}

const AutoReloadSelectField: React.FC<AutoReloadSelectFieldProps> = ({
  getIntervalLabel,
  intervalKeys,
  onIntervalChange,
  selectedInterval,
  storageKey,
}) => {
  const t = useAppTranslations()

  return (
    <FormControl fullWidth size="small">
      <InputLabel id={`${storageKey}-auto-reload-label`}>{t('commons.autoReload.label')}</InputLabel>
      <Select
        label={t('commons.autoReload.label')}
        labelId={`${storageKey}-auto-reload-label`}
        onChange={(event) => onIntervalChange(event.target.value)}
        value={selectedInterval}
        variant="outlined"
      >
        {intervalKeys.map((intervalKey) => (
          <MenuItem key={intervalKey} value={intervalKey}>
            {getIntervalLabel(intervalKey)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default AutoReloadSelectField
